import React from 'react';
import { 
    Container, Typography, Box, Grid, Paper, List, ListItem, 
    ListItemButton, ListItemIcon, ListItemText, Divider 
} from '@mui/material';
import { Link } from 'react-router-dom';

// Icons
import HomeIcon from '@mui/icons-material/Home';
import InfoIcon from '@mui/icons-material/Info';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import LoginIcon from '@mui/icons-material/Login';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import DashboardIcon from '@mui/icons-material/Dashboard';
import GavelIcon from '@mui/icons-material/Gavel';
import ShieldIcon from '@mui/icons-material/Shield';
import BusinessIcon from '@mui/icons-material/Business';
import SchoolIcon from '@mui/icons-material/School';
import LockIcon from '@mui/icons-material/Lock';

const SITE_STRUCTURE = [
    {
        category: "Public Pages",
        description: "General information available to everyone.",
        items: [
            { label: "Home", path: "/", icon: <HomeIcon color="primary" /> },
            { label: "About Us", path: "/about-us", icon: <InfoIcon color="primary" /> },
            { label: "Contact Support", path: "/contact", icon: <ContactSupportIcon color="primary" /> },
            { label: "FAQ", path: "/faq", icon: <ContactSupportIcon color="primary" /> },
        ]
    },
    {
        category: "Access & Onboarding",
        description: "Gateways to enter the platform.",
        items: [
            { label: "Sign In", path: "/login", icon: <LoginIcon color="secondary" /> },
            { label: "Register (Applicant)", path: "/register", icon: <AppRegistrationIcon color="secondary" /> },
            { label: "Register (Funder)", path: "/register?tier=GROWTH", icon: <BusinessIcon color="secondary" /> },
            { label: "Forgot Password", path: "/forgot-password", icon: <LockIcon color="disabled" /> },
        ]
    },
    {
        category: "Portals (Requires Login)",
        description: "Secure areas for managing funding.",
        items: [
            { label: "Applicant Dashboard", path: "/applicant/dashboard", icon: <SchoolIcon color="success" /> },
            { label: "Funder Dashboard", path: "/admin/dashboard", icon: <DashboardIcon color="warning" /> },
        ]
    },
    {
        category: "Legal & Compliance",
        description: "Terms, policies, and conditions.",
        items: [
            { label: "Privacy Policy", path: "/privacy-policy", icon: <ShieldIcon color="action" /> },
            { label: "Terms of Service", path: "/terms-of-service", icon: <GavelIcon color="action" /> },
        ]
    }
];

const SitemapPage = () => {
    return (
        <Box sx={{ minHeight: '80vh', py: 8, bgcolor: 'background.default' }}>
            <Container maxWidth="lg">
                <Box sx={{ textAlign: 'center', mb: 6 }}>
                    <Typography variant="h3" fontWeight="bold" gutterBottom color="primary">
                        Site Map
                    </Typography>
                    <Typography variant="h6" color="text.secondary">
                        Overview of the BrightSparc platform structure.
                    </Typography>
                </Box>

                <Grid container spacing={4}>
                    {SITE_STRUCTURE.map((section, index) => (
                        <Grid item xs={12} md={6} key={index}>
                            <Paper elevation={3} sx={{ h: '100%', borderRadius: 2, overflow: 'hidden' }}>
                                <Box sx={{ p: 3, bgcolor: 'action.hover', borderBottom: 1, borderColor: 'divider' }}>
                                    <Typography variant="h5" fontWeight="bold">
                                        {section.category}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {section.description}
                                    </Typography>
                                </Box>
                                <List sx={{ p: 0 }}>
                                    {section.items.map((item, i) => (
                                        <React.Fragment key={i}>
                                            <ListItem disablePadding>
                                                <ListItemButton component={Link} to={item.path} sx={{ py: 2 }}>
                                                    <ListItemIcon>
                                                        {item.icon}
                                                    </ListItemIcon>
                                                    <ListItemText 
                                                        primary={item.label} 
                                                        primaryTypographyProps={{ fontWeight: 'medium' }}
                                                    />
                                                </ListItemButton>
                                            </ListItem>
                                            {i < section.items.length - 1 && <Divider component="li" />}
                                        </React.Fragment>
                                    ))}
                                </List>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default SitemapPage;